// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import RouteSettingManagement from 'components/organisms/RouteSetting';
import styles from './RouteSettings.module.scss';
import { PrimaryTemplate } from 'components/templates/PrimaryTemplate';
import { useTranslation } from 'react-i18next';

function RouteSettings() {
  const { t } = useTranslation();

  return (
    <PrimaryTemplate
      h1={t('route_settings.title')}
      className={styles.container}
    >
      <RouteSettingManagement />
    </PrimaryTemplate>
  );
}

export default RouteSettings;
